export interface Alert {
    id: string;
    organizationID: string;
    day: string;
    alertType: AlertType | any; // using any for future types that might be added
    alertImportance: AlertImportance;
    timestamp: number;
    whatsappMessage: string;
    emailTitle: string;
    largeDescription: string;
    shortDescription: string;
    metadata: any;

    firestoreRecordId: string;
    firestoreCreationTimestamp?: number;
    firestoreUpdateTiemstamp?: number;
    firestoreMySQLSyncTimestamp?: number;
}

export interface AlertUserSummary {
    id: string;
    canonicalUserID: string;
    name?: string;
    email?: string;
    imageURL?: string;
    mobilePhone?: string;
    legajo?: string;
}

export interface AlertDashboardItem extends Alert {
    building?: Record<string, any>;
    buildingName?: string;
    shiftInstance?: Record<string, any>;
    shiftRecipe?: Record<string, any>;
    checkedInUsers: AlertUserSummary[];
    missingUsers: AlertUserSummary[];
    expectedCount: number;
    checkinCount: number;
    missingCount: number;
}

export interface AlertTableRow {
    id: string;
    organizationID: string;
    day: string;
    alertType: AlertType | any;
    alertImportance: AlertImportance;
    timestamp: number;
    emailTitle: string;
    shortDescription: string;
    buildingID?: string;
    buildingName?: string;
    shiftInstanceID?: string;
    shiftInstance?: Record<string, any>;
    recipeID?: string;
    shiftRecipeName?: string;
    expectedCount: number;
    checkinCount: number;
    missingCount: number;
}

export interface AlertDetail {
    alert: Alert;
    building?: Record<string, any>;
    buildingName?: string;
    shiftInstance?: Record<string, any>;
    shiftRecipe?: Record<string, any>;
    checkedInUsers: AlertUserSummary[];
    missingUsers: AlertUserSummary[];
    expectedCount: number;
    checkinCount: number;
    missingCount: number;
}

export enum AlertType {
    shiftCountControl = "SHIFT-COUNT",
    /** a kiosk evidence photo the anti-spoof check scored as a possible impersonation (printed photo / screen) */
    kioskEvidenceSpoof = "KIOSK-EVIDENCE-SPOOF",
}
export enum AlertImportance {
    low = "LOW",
    medium = "MEDIUM",
    high = "HIGH",
}


export interface Subscription {
    id: string;
    type: SubscriptionType | any; // using any for future types that might be added
    targetID: string;

    firestoreRecordId: string;
    firestoreCreationTimestamp?: number;
    firestoreUpdateTiemstamp?: number;
    firestoreMySQLSyncTimestamp?: number;
}
export enum SubscriptionType {
    whatsapp = "WHATSAPP",
    email = "EMAIL",
    slack = "SLACK",
}
